(() => {
  const DEBUG = false;
  const log = (...args) => {
    if (!DEBUG) return;
    console.debug("[cart-shield]", ...args);
  };

  let removalInFlight = false;

  const removeLines = async (lines) => {
    const cartComponent =
      document.querySelector("cart-drawer-items") ||
      document.querySelector("cart-items");

    if (cartComponent && typeof cartComponent.updateQuantity === "function") {
      log("Removing via cart component", lines);
      lines.forEach((line) => cartComponent.updateQuantity(line, 0));
      return;
    }

    if (!window.routes || !window.routes.cart_update_url) {
      window.location.reload();
      return;
    }

    const updates = {};
    lines.forEach((line) => (updates[line] = 0));

    try {
      log("Removing via fetch", updates);
      await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          updates,
          sections_url: window.location.pathname,
        }),
      });
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-shield" });
      }
    } catch (error) {
      console.error("Cart shield removal failed", error);
    }
  };

  const enforceCartShield = () => {
    if (removalInFlight) return;

    const rows = Array.from(document.querySelectorAll("[data-line]"));
    if (!rows.length) return;

    // Group cart rows by their bundle token and record whether each bundle
    // still has its main product line present.
    const groups = new Map();
    rows.forEach((row) => {
      const bundleId = (row.dataset.bundleId || "").trim();
      if (!bundleId) return;
      let group = groups.get(bundleId);
      if (!group) {
        group = { hasMain: false };
        groups.set(bundleId, group);
      }
      if ((row.dataset.bundleRole || "").trim() === "main") {
        group.hasMain = true;
      }
    });

    const linesToCull = [];
    rows.forEach((row) => {
      const line = parseInt(row.dataset.line, 10);
      if (Number.isNaN(line)) return;

      // Only bundle-only products (hidden_product template) may never remain in
      // the cart without their bundle main. Reachable accessories added through
      // a selector (e.g. cables) are allowed to stay on their own once the main
      // is removed, so they are intentionally left untouched here.
      if (row.dataset.bundleOnly !== "true") return;

      const bundleId = (row.dataset.bundleId || "").trim();
      const group = bundleId ? groups.get(bundleId) : null;
      const mainPresent = group ? group.hasMain : false;

      if (!mainPresent) linesToCull.push(line);
    });

    if (!linesToCull.length) return;

    log("Removing orphaned bundle lines", linesToCull);
    removalInFlight = true;
    removeLines([...new Set(linesToCull)]).finally(() => {
      removalInFlight = false;
    });
  };

  const scheduleEnforce = () =>
    window.requestAnimationFrame(() => enforceCartShield());

  document.addEventListener("DOMContentLoaded", scheduleEnforce);

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleEnforce);
  }

  document.addEventListener("cart-drawer:render", scheduleEnforce);
})();
